module.exports = __webpack_public_path__ + "static/11500-with-drawer-c83dc021a97deec1fef28ac2a3aa1034.jpg";